var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64411 10.671C4.08828 10.1943 4.76536 10.2322 5.15536 10.7522L5.70245 11.4835C6.1412 12.0631 6.85078 12.0631 7.28953 11.4835L7.83661 10.7522C8.22661 10.2322 8.9037 10.1943 9.34786 10.671C10.312 11.7002 11.0974 11.3589 11.0974 9.91808V3.8135C11.1029 1.63058 10.5937 1.0835 8.5462 1.0835H4.4512C2.4037 1.0835 1.89453 1.63058 1.89453 3.8135V9.91266C1.89453 11.3589 2.68536 11.6947 3.64411 10.671Z",
    stroke: "#C4D26E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 7.0415L8.125 3.7915",
    stroke: "#C4D26E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12333 7.04183H8.12819",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87333 4.06234H4.87819",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.2e5eb773a74bb96893274831e4885580.svg";
export { ForwardRef as ReactComponent };